import { IMindMeMobilePage } from "../interfaces";

export class MobilePageModel {
  id: string; 
  name: string;
  url: string;
  constructor(data?: Partial<MobilePageModel>) { 
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.url = data?.url || "";
  }

  static deserializeAPIModel(data: IMindMeMobilePage): MobilePageModel {
    const mappedData: Partial<MobilePageModel   > = {
      id: data.id,
      name: data.name,
      url: data.pageLink,
    };
    return new MobilePageModel(mappedData);
  }
}  